/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AutopaymentSetup/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Loading from './Loading/index'
import Pay from './Pay/index'
import React from 'react'
import Steps from './Steps/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AutopaymentSetup({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/ActiveStep/AutopaymentSetup",
  isSubmitting
  
}) {
let payersIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'payers',
})
  return (<React.Fragment
>
<div
  data-testid="AutopaymentSetup.Vertical"
  data-view-path={viewPath}
 style={{'--oy-1-Z4s7Mr': payersIsSubmittingData ? "hidden" : "auto"}}
 className={`views-block ${styles.Vertical}`}
>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
<Steps
  viewPath={`${viewPath}/Steps`}
/>
<div
  data-testid="AutopaymentSetup.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<Pay
  viewPath={`${viewPath}/Pay`}
/>
</div>
</div>
{children}
</React.Fragment>)
}